import * as React from 'react';
import S from 's-js';
import { FocusGroup, FocusEventHandlers } from 'lib/focusGroup';
import { SuperCriticalComponent } from 'lib/supercritical';
import { MeasurementInFeetAndInches } from 'lib/MeasurementInFeetAndInches';
import { NullableNumericInput } from 'portcall/numericinput/view';

interface FeetAndInchesProps {
    model: MeasurementInFeetAndInches,
    disabled?: boolean,
    placeholder?: string
    tabindex?: { feet?: number, inches? : number }
    autoFocus?: boolean
    onFocus? : () => void;
    onBlur?: () => void;
}

export class FeetAndInches extends SuperCriticalComponent<FeetAndInchesProps> {
    feetFocus   : FocusEventHandlers;
    inchesFocus : FocusEventHandlers;

    constructor(props : FeetAndInchesProps) {
        super(props);

        const focusGroup = new FocusGroup({
            onFocus: () => this.sprops().onFocus?.(),
            onBlur: () => S.freeze(() => {
                this.sprops().model.RelinquishWriter();
                this.sprops().onBlur?.();
            })
        });
        this.feetFocus   = focusGroup.enroll().events;
        this.inchesFocus = focusGroup.enroll().events;
    }

    srender({ model, disabled, placeholder, tabindex, autoFocus } : FeetAndInchesProps) {
        return (
            <span className="feetandinches">
                <NullableNumericInput className="feetandinches-input feetandinches-feet"
                    value={model.Feet}
                    disabled={disabled}
                    placeholder={placeholder}
                    tabindex={tabindex && tabindex.feet}
                    autoFocus={autoFocus}
                    {...this.feetFocus}
                />
                <span className="feetandinches-uom">ft.</span>
                <NullableNumericInput className="feetandinches-input feetandinches-inches"
                    value={model.Inches}
                    disabled={disabled}
                    placeholder={placeholder}
                    tabindex={tabindex && tabindex.inches}
                    {...this.inchesFocus}
                />
                <span className="feetandinches-uom">in.</span>
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/feetandinches/view.tsx